<div class="mzic-badge" [ngClass]="theme">
  @if (iconSrc) {
    <mzic-svg
      [src]="iconSrc"
      [ngClass]="theme === 'dark' ? 'w12  neutral-300' : 'w12  neutral-700'" />
  }
  <span class="badge-text">{{ displayText }}</span>
  @if (showCopy) {
    <button class="copy-button" (click)="onCopyClick()" [title]="copyTitle">
      <mzic-svg
        src="assets/icons/mzic-copy.svg"
        [ngClass]="theme === 'dark' ? 'w12 neutral-300' : 'w12 neutral-700'" />
    </button>
  }
</div>
